import { MenuItem, TextField } from '@mui/material';
import React, { memo, useCallback } from "react";
import PropTypes from 'prop-types';
import { StyleShape } from '../../../types';

function SelectDefaultNodeShape({ value, handleChange }) {
  const handleStyleShapeChange = useCallback((event) => {
    handleChange({
      target: {
        name: "defaultshapetype",
        value: event.target.value
      }
    });
  }, [handleChange]);

  return (
    <div>
      <TextField 
        id="template-style-shape" 
        select 
        label="Shape style" 
        size="small" 
        margin="dense" 
        value={value} 
        onChange={handleStyleShapeChange} 
        fullWidth>
        {StyleShape.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}

SelectDefaultNodeShape.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default memo(SelectDefaultNodeShape);